export default __webpack_public_path__ + "static/media/ShiftComplete.c6ed7447.png";